import GraduatedCard from "../components/graduatedCard"
import Heading from "../components/heading"
// import g1 from "../assets/g1.svg"
import DraggableScrollableList from "../components/draggableList"
import {  useRef, useState } from "react"
// import axios from "axios"
// import { apis } from "../api/apiUrl"
// import { showImage } from "../api/functions"
import { GraduatedCardSkelton } from "../components/skeltons"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { retrunAssets } from "../utils/getAssets"
// import { useInView } from "framer-motion"

const OurGraduates = () => {
   
    const ref = useRef(null)
    // const isInViewRef = useInView(ref, { once: true });
    
    const [loading,] = useState(false)
    
    // const graduates = [
    //     {
    //         img: g1,
    //         name: "Aida Liyana",
    //         course: "Bachelor of Information Technology (Graphics & Multimedia) (Hons)",
    //         quote: "Life is tough, but so am I"
    //     },
    //     {
    //         img: g2,
    //         name: "Muhammad Ashraf Hamil",
    //         course: "Bachelor of Computer Science (Software Engineering) (Hons)",
    //         quote: "work hard so that you have your own toilet at the office"
    //     },
    //     {
    //         img: g3,
    //         name: "Sean Lam Kah Choon",
    //         course: "Bachelor of Computer Science (Cyber Security) (Hons)",
    //         quote: "Slow is Smooth, Smooth is Fast"
    //     },
    //     {
    //         img: g4,
    //         name: "Siti Nurfarahana Binti Omar",
    //         course: "Bachelor of Computer Science (Software Engineering) (Hons)",
    //         quote: "Fly higher, because we cant forever in same level"
    //     },

    // ]
    const state = useSelector(state => state.homepage)
    const data = state.data?.properties?.graduates?.items.map(d => {
        return {
            img: retrunAssets(d?.content?.properties?.image[0].url),
            name: d?.content?.properties?.graduateName,
            course: d?.content?.properties?.course,
            quote: d?.content?.properties?.quotes
        }
    }
    )
    return (
        <div ref={ref} className="relative bg-white text-black flex items-start justify-center p-4">
            <div className=" w-full min-h-[30rem]  h-full flex flex-col items-center justify-center  p-4 gap-3">
                <Heading name="Our People" />
                <h1 className="text-3xl font-bold text-center">What Our Graduates Say?</h1>
                <p className="md:text-xs 2xl:text-[16px] 2xl:leading-7 text-[#888888] md:max-w-[45%] text-center w-full">Discover firsthand accounts of their triumphs, challenges overcome, and the
                    invaluable lessons learned during their time at our esteemed institution.</p>
                    {/* <Link to={"/our people"} className='p-2 px-3  border w-fit rounded-sm font-bold my-2 text-xs 2xl:text-sm text-[#0039cb] border-[#0039cb] flex items-center gap-1'>View All</Link> */}

                <DraggableScrollableList >
                    {
                        loading ?
                            <>
                                {[1, 2, 3, 4].map(item =>

                                    <GraduatedCardSkelton key={item} />

                                )
                                }
                            </>
                            :
                            data?.map((graduate, index) => (
                                <GraduatedCard key={index} {...graduate} />
                            ))
                    }
                </DraggableScrollableList>
            </div>
        </div>
    )
}

export default OurGraduates